import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "dropdown", "selectedMovie"];
  static values = {
    url: String,
    selected: Array,
  };

  connect() {
    this.hideDropdown();
    document.addEventListener("click", this.handleClickOutside.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside.bind(this));
  }

  search() {
    const query = this.inputTarget.value;

    if (query.length < 2) {
      this.hideDropdown();
      return;
    }

    this.showDropdown();

    fetch(`/admin/movies/search?query=${encodeURIComponent(query)}`, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then((response) => response.text())
      .then((html) => {
        this.dropdownTarget.innerHTML = html;
      });
  }

  selectMovie(event) {
    event.preventDefault();
    const movieId = event.currentTarget.dataset.movieId;
    const movieTitle = event.currentTarget.textContent.trim();

    // Update the hidden input for Rails
    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = "article[movie_ids][]";
    hiddenInput.value = movieId;
    this.element.appendChild(hiddenInput);

    // Update the visual selection
    this.selectedMovieTarget.textContent = movieTitle;
    this.selectedMovieTarget.classList.remove("hidden");

    // Clear and hide search
    this.inputTarget.value = "";
    this.hideDropdown();
  }

  removeMovie(event) {
    event.preventDefault();
    event.stopPropagation();

    // Remove the hidden input
    const hiddenInputs = this.element.querySelectorAll(
      `input[name="article[movie_ids][]"]`
    );
    hiddenInputs.forEach((input) => input.remove());

    // Clear the visual selection
    this.selectedMovieTarget.textContent = "";
    this.selectedMovieTarget.classList.add("hidden");

    // Show the input again
    this.inputTarget.value = "";
    this.inputTarget.focus();
  }

  showDropdown() {
    this.dropdownTarget.classList.remove("hidden");
  }

  hideDropdown() {
    this.dropdownTarget.classList.add("hidden");
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideDropdown();
    }
  }
}
